import {getAllIncidentsSource} from 'actions/statuspage'
import {createContext, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'

export const StatusPageContext = createContext()

const StatusPageProvider = ({children}) => {
  const dispatch = useDispatch()

  const {IncidentsSourceList = []} = useSelector(state => state.statuspage)

  useEffect(() => {
    dispatch(getAllIncidentsSource())
  }, [dispatch])

  const sourceOptions = useMemo(() => {
    return (
      IncidentsSourceList?.map(list => ({
        value: list.id,
        key: list.id,
        text: list.source,
      })) ?? []
    )
  }, [IncidentsSourceList])

  return <StatusPageContext.Provider value={{sourceOptions}}>{children}</StatusPageContext.Provider>
}

export default StatusPageProvider
